export default __webpack_public_path__ + "static/media/bg-auth.f76f8d66.jpg";